// priceRules.js

const priceRules = [
    {
      id: "sideLite",
      formula: "((doorData.frameData.sideLiteSize * doorData.frameData.frameHeight)/144) * <<price1>>",
      price1: ["ref_sideLiteGlass", "doorData.sideLite.sideLiteOptionsS_label"],
      price2: ["Gentek", "doorData.frameData.frameColor"],
      unitPrice: 7,
      multiplicator: {
        condition: "doorData.frameData.selectedDoor?.id === 4 || doorData.frameData.selectedDoor?.id === 8",
        value: 2
      }
    },
    { id: "ref_sideLiteGlass", Clear: 1, Sandblasted: 2, Delta: 3 },
    { id: `ref_doorGlass`, Clear: 0.2, Sandblasted: 0.4, Delta: 0.8 },
    { id: `ref_sillOptions`, Standard: 20, Handicap: 30 },
    {
      id: "sillOptions",
      formula: "<<price1>>",
      price1: [`ref_sillOptions`, "doorData.frameData.sillOptions"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "doorGlass",
      formula: "<<price1>>",
      price1: [`ref_doorGlass`, "doorData.doorLite.optionsS_label"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "frameSize",
      formula: "((doorData.frameData.frameWidth * doorData.frameData.frameHeight)/144) * <<price1>>",
      price1: [`ref_doorGlass`, "doorData.doorLite.optionsS_label"],
      unitPrice: 200,
      minValue: 2
    },
    {
      id: "transom",
      formula: "(doorData.transomData.transomW * doorData.transomData.transomH)/144",
      unitPrice: 200,
      minValue: 1
    },
    {
      id: "doorGrills",
      formula: "(Number(doorData.doorLite.glassDividersHorizontal || -1) + 1) * (Number(doorData.doorLite.glassDividersVertical || 0) + 1)",
      unitPrice: 10,
      minValue: 0,
      multiplicator: {
        condition: "doorData.frameData.selectedDoor?.id > 4",
        value: 2
      }
    },
    {
      id: "sideLiteGrills",
      formula: "(Number(doorData.sideLite.glassDividersHorizontal || -1) + 1) * (Number(doorData.sideLite.glassDividersVertical || 0) + 1)",
      unitPrice: 10,
      minValue: 0,
      multiplicator: {
        condition: "(doorData.frameData.selectedDoor?.id === 4) || (doorData.frameData.selectedDoor?.id === 8)",
        value: 2
      }
    },
    {
      id: "hinges",
      formula: null,
      unitPrice: 12.5,
      minValue: null
    },
    { id: `ref_CascadingCombo`, 'Key Lock for Tilt and Turn': 20, A: 30, B: 40, C: 50 },
    {
      id: "CascadingCombo1",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo1"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "CascadingCombo2",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo2"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "CascadingCombo3",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo3"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "CascadingCombo4",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo4"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "CascadingCombo5",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo5"],
      unitPrice: 1,
      minValue: 0
    }
  ];
  
  export default priceRules;
  